module.exports = __webpack_public_path__ + "img/btn-add.4cc8c973.svg";